import { useEffect } from 'react';
import { AlloyButton, InlineLoader } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ShareCartChildModal from '../../ShareCartChildModal';
import ExceptionFeedbackBySelector from '@app/components/common/Exception/ExceptionFeedbackBySelector';
import { PCC_SHOPPING_CART_LOGGEDIN } from '../../../constants';
import { buildShareCartLink } from '@app/store/checkout/actions';
import { useSystemFeedback } from '@app/hooks';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { STATUS } from '@app/constants/commonConstants';

const NonDealerShareCartModal = ({ errorSelector, closeModal, isOpen }) => {
  const { values } = useFormikContext();
  const [t] = useTranslation();
  const { setError, clearError } = useSystemFeedback();
  const dispatch = useDispatch();
  const shareCartStatus = useSelector(s => s.checkout?.shareCartStatus);
  const shareCartLoader = shareCartStatus === STATUS.PENDING;
  const statusRejected = shareCartStatus === STATUS.REJECTED;

  const getShareCartLink = () => {
    const requestBody = {
      appName: PCC_SHOPPING_CART_LOGGEDIN,
      campaignId: PCC_SHOPPING_CART_LOGGEDIN,
      equipment: values?.equipment
    };
    const message = { message: t('UNKNOWN_ERROR_MESSAGE') };
    dispatch(buildShareCartLink(requestBody, setError, message)).then(res => {
      if (res) {
        clearError(ERROR_DOMAIN.CHECKOUT, ERROR_PATH.SHARE_CART_MODAL);
      }
    });
  };

  useEffect(() => {
    if (isOpen) {
      getShareCartLink();
    }
  }, [isOpen]);

  if (shareCartLoader) {
    return <InlineLoader />;
  }

  if (statusRejected) {
    return (
      <ExceptionFeedbackBySelector
        selector={errorSelector}
        skipTranslation
        className="mb-2"
      >
        <AlloyButton
          buttonType="secondary"
          className="my-3 me-4"
          size="small"
          onClick={getShareCartLink}
        >
          {t('RETRY')}
        </AlloyButton>
      </ExceptionFeedbackBySelector>
    );
  }

  return <ShareCartChildModal close={closeModal} />;
};

NonDealerShareCartModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  errorSelector: PropTypes.func
};

export default NonDealerShareCartModal;
